import React, {useState, useCallback, useEffect} from 'react';
import {getAllDeliveries} from '../../../services/OrderService';
import DeliveryHistoryList from '../../components/OrderHistory/DeliveryHistoryList';

const DeliveryHistory = () => {
    const [deliveryData, setDeliveryData] = useState({
        data: [],
        current_page: 1,
        total_pages: 1,
    });
    const [pageItems, setPageItems] = useState(10);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isInitialized, setIsInitialized] = useState(false);

    const getDeliveries = useCallback(
        (page = 1, itemsPerPage = pageItems) => {
            getAllDeliveries(page, itemsPerPage, fromDate, toDate)
                .then(response => {
                    if (response && response.data) {
                        setDeliveryData({
                            data: Array.isArray(response.data)
                                ? response.data
                                : [],
                            current_page: response.current_page || 1,
                            total_pages: response.total_pages || 1,
                        });
                    } else {
                        // Handle empty or invalid response
                        setDeliveryData({
                            data: [],
                            current_page: 1,
                            total_pages: 1,
                        });
                    }
                    setPageItems(itemsPerPage);
                })
                .catch(error => {
                    console.error('Error fetching deliveries:', error);
                    // Set empty data on error
                    setDeliveryData({
                        data: [],
                        current_page: 1,
                        total_pages: 1,
                    });
                });
        },
        [fromDate, toDate, pageItems]
    );

    const handlePageChange = page => {
        getDeliveries(page, pageItems);
    };

    const handlePageItemsChange = items => {
        setPageItems(items);
        getDeliveries(1, items);
    };

    const handleDateFilter = (from, to) => {
        // Update state first
        setFromDate(from);
        setToDate(to);

        // Then fetch data with the updated filters
        // Use the parameters directly rather than state variables
        // since state updates are asynchronous
        getAllDeliveries(1, pageItems, from, to)
            .then(response => {
                if (response && response.data) {
                    setDeliveryData({
                        data: Array.isArray(response.data) ? response.data : [],
                        current_page: response.current_page || 1,
                        total_pages: response.total_pages || 1,
                    });
                } else {
                    setDeliveryData({
                        data: [],
                        current_page: 1,
                        total_pages: 1,
                    });
                }
            })
            .catch(error => {
                console.error('Error filtering deliveries:', error);
                setDeliveryData({
                    data: [],
                    current_page: 1,
                    total_pages: 1,
                });
            });
    };

    // Initialize component with data on first render
    useEffect(() => {
        if (!isInitialized) {
            getDeliveries(1, pageItems);
            setIsInitialized(true);
        }
    }, [getDeliveries, isInitialized, pageItems]);

    return (
        <DeliveryHistoryList
            deliveryList={deliveryData.data}
            getDeliveries={getDeliveries}
            pagination={{
                currentPage: deliveryData.current_page,
                totalPages: deliveryData.total_pages,
            }}
            pageItems={pageItems}
            onPageChange={handlePageChange}
            onPageItemsChange={handlePageItemsChange}
            onDateFilter={handleDateFilter}
        />
    );
};

export default DeliveryHistory;
